import { render } from "./CourseOverview.vue?vue&type=template&id=8ee73c0c"
import script from "./CourseOverview.vue?vue&type=script&lang=js"
export * from "./CourseOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__